import { computed, type CSSProperties } from 'vue'
import { useI18n } from 'vue-i18n'
import { useThemeStore } from '@/stores/theme'
import { tenantBrandingString } from '@/services/api/tenant-branding'
import { useTenantBrandingStore } from '@/stores/tenant-branding'

/**
 * Read-only display helpers for public tenant branding (sidebar, login).
 */
export function useTenantBrandingDisplay() {
  const { t } = useI18n()
  const brandingStore = useTenantBrandingStore()
  const themeStore = useThemeStore()

  const displayName = computed(() => {
    const b = brandingStore.branding
    return `${tenantBrandingString(b, 'shopName') || tenantBrandingString(b, 'appDisplayName')}`.trim()
  })

  const tagline = computed(() => tenantBrandingString(brandingStore.branding, 'tagline').trim())

  const logoUrl = computed(() => {
    const b = brandingStore.branding
    const dark = tenantBrandingString(b, 'logoUrlDark').trim()
    if (themeStore.isDark && dark) {
      return dark
    }
    return `${tenantBrandingString(b, 'websiteLogoUrl') || tenantBrandingString(b, 'appLogoUrl')}`.trim()
  })

  const logoAlt = computed(() => displayName.value || t('app.name'))

  const headingStyle = computed<CSSProperties>(() => {
    const h = tenantBrandingString(brandingStore.branding, 'fontFamilyHeading').trim()
    return h ? { fontFamily: h } : {}
  })

  return {
    displayName,
    tagline,
    logoUrl,
    logoAlt,
    headingStyle,
    branding: brandingStore.branding,
  }
}
